import TaskAnalysisProgress from '@op/pages/AIAnalysisHub/KeywordAndURLAnalysis/component/TaskAnalysis';
import React, { useEffect } from 'react';
import { useTopicTaskCallbackStatus } from '../../../hook/useTopicAnalysisFlow';

export default function TopicProgressCard({
  wholeGameInfo,
  requestInfo,
  filter,
  isStop, 
  defaultExpanded,
  successTagged
}: {
  wholeGameInfo: any;
  requestInfo: () => Promise<void>;
  filter: any;
  isStop: boolean; 
  defaultExpanded:boolean;
  successTagged?:boolean;
}) {
  const {
    requestTopicTaskStatus,
    steps,
    taskStatus,
    isExpanded,
    setIsExpanded,
    taskTime
  } = useTopicTaskCallbackStatus({
    timer: 30 * 1000,
    requestInfo, 
    defaultExpanded
  });

  useEffect(() => {
    if (filter) {
      requestTopicTaskStatus(filter);
    }
  }, [filter]);

  return (
    <div style={{ margin: '16px 0' }}>
      <TaskAnalysisProgress
        expanded={isExpanded}
        onExpandChange={setIsExpanded}
        steps={steps}
        enableAnimation={false}
        isStop={isStop}
        taskTime={taskTime}
        taskStatus={taskStatus}
        successTagged={successTagged}
        // stepDelay={800}
        // typewriterDelay={20}
        gameCover={wholeGameInfo?.cover}
        className="keyword-analysis-task-progress"
      />
    </div>
  );
}
